import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '../app-routing.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ErrorCatchingInterceptor } from './interceptors/error-catching.interceptor';
import { DataLoaderInterceptor } from './interceptors/data-loader.interceptor';
import { AuthModule } from './views/login/auth.module';
import { ReportsModule } from './views/reports/reports.module';
import { AnnouncedContractedComponent } from './views/reports/announced-contracted/announced-contracted.component';

@NgModule({
  declarations: [
    AnnouncedContractedComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    CommonModule,
    NgbModule,
    NgMultiSelectDropDownModule.forRoot(),
    AuthModule,
    ReportsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorCatchingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DataLoaderInterceptor,
      multi: true,
    },
  ],
  bootstrap: [],
  exports: [],
})
export class OnelogModule {}
